exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background-color: #ffffff;\n  padding: 4px;\n  margin: 10px;\n  padding: 10px;\n  box-shadow: 1px 1px #e6e2e2; }\n\n.label-small {\n  font-size: 10px; }\n\n.b-title {\n  text-align: center;\n  border: 1px solid #ccc;\n  height: 40px;\n  padding: 10px;\n  font-size: 16px;\n  font-weight: 900; }\n\n.b-body {\n  height: 40px;\n  padding: 10px;\n  text-align: center;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  font-weight: 400; }\n\n.b-body-total {\n  width: 75%;\n  border: 1px solid #ccc;\n  text-align: center;\n  padding: 6px;\n  background-color: #f5f5f5;\n  font-size: 16px;\n  font-weight: 800; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/mobile/pd-check-result.scss
// module id = ../../../../../src/app/pages/mobile/pd-check-result.scss
// module chunks = 39